import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import type { Complexity, PitchPaletteSource } from "@/shared/modal.api";
import { isObject } from "@/shared/utils/typeGuards";

export const kVariations20Route = "/variations-2.0";

export interface Variations20RequestBody {
    fileKey: string;
    bpm: number;
    pitchPalette?: number[];
    pitchPaletteSource?: PitchPaletteSource;
    complexity?: Complexity;
    naturalness?: number;
    uniformity?: number;
    transposition?: number;
}

export const isVariations20RequestBody = (value: unknown): value is Variations20RequestBody =>
    isObject(value) && typeof value.fileKey === "string" && typeof value.bpm === "number";

export const kVariations20Endpoint: ApiEndpoint<Variations20RequestBody, DownloadUrlResponse> = {
    route: kVariations20Route,
    label: "Variations 2.0",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v2.0",
    description: "Generates AI variations of a loop using the SpliceGen 2.0 pitch palette model.",
    isRequestBody: isVariations20RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
